<template>
  <v-row justify="center">
    <v-col md="8" lg="6" xl="4">
      <v-card>
        <v-form @submit.prevent="save" ref="editForm">
          <v-card-title>
            <h2>{{ $t("admin.events.settings.advanced.title") }}</h2>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :label="$t('admin.events.settings.advanced.wallRedirectUrl')"
              maxlength="255"
              v-model="event.brandingWallRedirectUrl"
              :disabled="view"
              :hint="$t('admin.events.settings.advanced.wallRedirectUrlHint')"
            ></v-text-field>
            <v-textarea
              v-model="event.helpDeskEmbedCode"
              :label="$t('admin.events.settings.advanced.helpDeskEmbedCode')"
              auto-grow
              :disabled="view"
            ></v-textarea>
            <v-textarea
              v-model="event.helpDeskEmbedCodeStyle"
              :label="$t('admin.events.settings.advanced.helpDeskEmbedCodeStyle')"
              auto-grow
              :disabled="view"
            ></v-textarea>
            <v-text-field
              v-model="editedSlug"
              :label="$t('admin.events.settings.advanced.slug')"
              maxlength="255"
              :disabled="view"
              :error-messages="notUniqueSlugMessage"
              @keydown="clearSlugMessage"
            ></v-text-field>
            <v-switch
              :disabled="view"
              :label="$t('admin.events.settings.advanced.enableLobby')"
              v-model="event.enableLobby"
            >
            </v-switch>
            <v-switch
              :disabled="view"
              :label="$t('admin.events.settings.advanced.restrictedAccess')"
              v-model="event.restrictedAccess"
            >
            </v-switch>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" v-if="!view">
              {{ $t("admin.events.settings.advanced.save") }}
            </v-btn>
            <v-btn color="primary" v-if="view" @click="edit()">
              {{ $t("admin.events.settings.content.edit") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import slugify from "slugify";

export default {
  name: "settings.advanced",
  data() {
    return {
      view: true,
      editOn: true,
      event: {},
      notUniqueSlugMessage: null,
      editedSlug: "",
    };
  },
  mounted() {
    this.getEventFromApi();
  },
  watch: {
    "event.slug": {
      handler() {
        this.event.slug = slugify(`${this.event.slug.toLowerCase()}`, {
          lower: true,
          strict: true,
        });
      },
    },
  },
  methods: {
    async getEventFromApi() {
      this.loading = true;
      this.event = await axios.get(`/admin/events/${this.$route.params.eventId}`);
      this.editedSlug = this.event.slug;
      this.loading = false;
    },
    async save() {
      if (this.editOn) {
        this.editOn = false;
        return;
      }
      if (this.event.slug !== this.editedSlug) {
        const exist = await this.$axios.get("/admin/events/isSlugExist", { params: { slug: this.editedSlug }});
        if (exist) {
          this.notUniqueSlugMessage = this.$t("errors.validator.notUniqueSlugMessage");
          return;
        }
      }
      await axios.put(`/admin/events/${this.$route.params.eventId}`, this.event);
      this.$store.commit("SUCCESS", this.$t("admin.events.settings.advanced.msgSaved"));
      this.view = true;
      this.editOn = false;
      location.reload();
    },
    edit() {
      this.view = false;
      this.editOn = true;
    },
    clearSlugMessage() {
      this.notUniqueSlugMessage = null;
      this.$refs.editForm.resetValidation();
    },
  },
};
</script>

<style scoped></style>
